import React from "react";
import { UserInterface } from "../../../../store/sticker_maker/usersSlice";
import { formattedDate } from "../../../../helpers/DateHelpers";

import Meta, { MetaInterface } from "../../../../componets/Meta";
import { UserOutlined } from "@ant-design/icons";

interface _MetaInterface {
  user: UserInterface | undefined;
  size?: MetaInterface['size'];
  shape?: MetaInterface['shape'];
  className?: string;
}

const _Meta = ({ user, shape, size, className }: _MetaInterface) => {
  if (!user) {
    return null;
  }

  return (
    <Meta
      url={user.url}
      size={size}
      shape={shape}
      avatar={user.avatar_url}
      fallback={UserOutlined}
      title={user.username}
      description={
        <small>{`Seen: ${formattedDate(user.launch_at).fromNow}`}</small>
      }
      className={className}
    />
  );
}

export default _Meta;
